import { createPortal } from "react-dom"
import styled from "styled-components"
import { Button, Modal } from "@prosolve/common-components-ui"
import { FaPlay, FaTimes } from "react-icons/fa"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 420px;
  max-width: calc(100vw - 80px);
`

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const MutedText = styled.div`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 13px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 10px;
`

export default ({
  job,
  title = 'Run Job',
  description = 'This will trigger the job immediately outside of its schedule.',
  onConfirm,
  onClose
}) => {
  const footer = (
    <ButtonsContainer>
      <Button onClick={onClose}>
        <RowGroup>
          <FaTimes />
          Cancel
        </RowGroup>
      </Button>
      <Button $colored={true} onClick={onConfirm}>
        <RowGroup>
          <FaPlay />
          Run Now
        </RowGroup>
      </Button>
    </ButtonsContainer>
  )

  return createPortal(
    <Modal
      title={title}
      isAutoHeight={true}
      isAutoWidth={true}
      onClose={onClose}
      footer={footer}
    >
      <ModalContainer>
        <div>Run {job.name} now?</div>
        <MutedText>{description}</MutedText>
      </ModalContainer>
    </Modal>,
    document.body
  )
}
